import { Outlet, useNavigate } from 'react-router-dom';
import { Home, Wrench } from 'lucide-react';
import useAuthStore from '../store/useAuthStore';

const FEED_DISABLED = import.meta.env.VITE_FEED_DISABLED === 'true';

export default function FeedGuard() {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  // Для администратора раздел доступен всегда
  if (user?.role === 'admin') return <Outlet />;

  if (FEED_DISABLED) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[100dvh] bg-[#f8f9fc] px-6 text-center">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-5">
          <Wrench className="w-7 h-7 text-slate-400" strokeWidth={1.5} />
        </div>
        <h2 className="text-[18px] font-bold text-slate-800 mb-2">Раздел в разработке</h2>
        <p className="text-[14px] text-slate-500 leading-relaxed mb-7 max-w-[260px]">
          Лента временно недоступна. Мы уже работаем над этим — скоро всё будет готово.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 active:bg-blue-700 text-white text-[14px] font-semibold px-6 py-3 rounded-[14px] transition-colors"
        >
          <Home size={16} strokeWidth={2.5} />
          На главную
        </button>
      </div>
    );
  }

  return <Outlet />;
}
